import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";

const PaginationContainer = styled.div<IStyledComponentProps>`
  &.pagination-container {
    display: flex;
    margin: 12px 0;
    justify-content: center;
    width: 100%;
    &:first-child {
      margin-bottom: 0;
    }

    .page-item {
      &.disabled {
        .page-link {
          background-color: ${({ theme }) => theme.colors.grays.senary};
          border-color: ${({ theme }) => theme.colors.grays.senary};
        }
      }
    }
  }
`;

export default {
  PaginationContainer,
};
